/* eslint-disable class-methods-use-this */
define(
  'builderShowcaseVideoHandler',[
    'builderShowcaseObserver',
    'brightcoveVideoPlayer',
    'vimeoVideoPlayer',
    'youtubeVideoPlayer'
  ],
  (
    builderShowcaseObserver
  ) => {
    'use strict';

    class VideoHandler {
      constructor(configObject) {
        this.config = configObject;
        this.videoElement = null;
        this.playerToUse = null;
        this.videoPlayers = {
          brightcove: window.NewHomeSource.videoPlayers.brightcove.Player,
          vimeo: window.NewHomeSource.videoPlayers.vimeo.Player,
          youtube: window.NewHomeSource.videoPlayers.youtube.Player,
        };
      }

      /**
      * @private
      * findPlayer: selects the player to use from [youtube, vimeo, brightcove]
      */
      findPlayer(data) {
        const playerName = data.VideoType.toLowerCase();
        return this.videoPlayers[playerName];
      }

      /**
      * @private
      * pauseOtherPlayingVideo: pauses any video playing in the background so the user
       * does not have to manually pause it before opening a new one.
      */
      pauseOtherPlayingVideo() {
        const state = builderShowcaseObserver.getState();
        const playingVideo = state.data.playingVideo;
        if (!playingVideo) {
          return;
        }

        playingVideo.pause();
      }

      /**
      * @private
      * playVideoOnLoaded: return true if the video needs to be auto played, false otherwise.
      */
      playVideoOnLoaded(data) {
        if (data.playOnLoaded !== undefined) {
          return data.playOnLoaded;
        }

        return true;
      }

      /**
       * Method subscribed to OnImageSelected event,
       * this will receive the active image object as input to build and replace the marquee main image.
       * @param {object} data active image object
       */
      update(data) {
        this.pauseOtherPlayingVideo();
        this.config.mainViewer.innerHTML = '';
        const marqueecontainer = this.config.mainViewer.closest('[data-marquee-component="gallery"]');

        if (this.playerToUse) {
          this.playerToUse.dispose();
        }

        if (!data || !data.VideoType) {
          if (marqueecontainer) {
            marqueecontainer.classList.remove('gallery--video');
          }

          return;
        }

        this.playerToUse = this.findPlayer(data);
        const handler = {
          playOnLoaded: this.playVideoOnLoaded(data),
        };

        this.videoElement = this.playerToUse.createContainer(100, 100);
        const containerDiv = document.createElement('DIV');
        containerDiv.className = 'gallery-box__video';
        containerDiv.id = 'nhs_VideoContainer';
        containerDiv.appendChild(this.videoElement);
        this.config.mainViewer.prepend(containerDiv);
        this.videoElement.id = `${this.config.componentName}-${data.VideoId}`;
        this.playerToUse(this.videoElement.id, data.VideoId, handler);

        builderShowcaseObserver.setData({ playingVideo: Object.assign({}, this.playerToUse) });
        builderShowcaseObserver.commit();

        if (marqueecontainer) {
          marqueecontainer.classList.add('gallery--video');
        }
      }
    }

    return VideoHandler;
  }
);

